export function NonSelectableView({children}) {
    return <div style={{userSelect: "none"}}>
        {children}
    </div>
}